import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
import { useSelector } from "react-redux";
import FileUploader from "../../../reusableComponents/FileUploader2";
import KmlFileUploader from "../../../../TCPForms/reusableComponents/KmlFileUploader";
import LowRiskDisclaimer from "../../../../../../components/LandUseNOC/LowRiskDisclaimer";


const SubStep4 = ({ formData, handleTabChange, isEmployee, handleSubTabChange }) => {
    const { t } = useTranslation();
    const { documents } = useSelector(state => state.formMT);
    const [showError, setShowError] = useState(false);
    const defaultValues = { 
        ...formData,
        descriptionOfLand: {
            ...formData?.descriptionOfLand
        },
    };
    const { handleSubmit, control, setValue, watch, reset, getValues } = useForm({ defaultValues });

    useEffect(() => {
        setValue('documents', documents)
    }, [documents]);

    const onSubmit = (data) => {
        handleTabChange(1, data)
    };
    return (
        <section className="groupContainer">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="formContainer">
                    <div className="formHeaderContainer">
                        <h2 className="formHeading">GEO Location</h2>
                    </div>

                    <div className="formInputContainer common-app-form">
                        <div className="columnWrapper">
                            <InputWrapper
                                label="Latitude"
                                control={control}
                                placeholder="Enter Latitude"
                                name="descriptionOfLand.latitude"
                                type="textInput"
                                mandatory
                                defaultValue={formData?.descriptionOfLand?.latitude}
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required",
                                    },
                                }}
                                maxLength={10}
                                disabled={formData?.descriptionOfLand?.latitude}
                            />
                            
                             {/* <FileUploader
                                label={t("Upload KML File Option")}
                                control={control}
                                name="kmlFile"
                                validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                                required
                                isMandatory
                                tab={1}
                                maxFiles={1}
                            />  */}
                           {/* {!isEmployee && <KmlFileUploader
                                name={"kmlFile"}
                                label={"KML File"}
                                isMandatory
                                validationMsg={"(.kml file only and Max file Size 10 MB)"}
                                required
                                tab={1}
                                showError={showError}
                                // control={control}
                                maxFiles={1}
                            />} */}

                        </div>
                        <div className="columnWrapper">
                            <InputWrapper
                                label="Longitude"
                                control={control}
                                placeholder="Enter Longitude"
                                name="descriptionOfLand.longitude"
                                type="textInput"
                                mandatory
                                defaultValue={formData?.descriptionOfLand?.longitude}
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required",
                                    },
                                }}
                                maxLength={10}
                                disabled={formData?.descriptionOfLand?.longitude}
                            />


                        </div>
                        <br />
                    </div>

                </div>
                {!isEmployee && <div className="footerContainer">
                    <div className="buttonWrapper">
                        <ButtonWrapper
                            variant="contained"
                            color="error"
                            size="medium"
                            label="Prev"
                            sx={{ backgroundColor: '#CCC' }}
                            onClick={() => handleSubTabChange(2)}
                        />
                        <ButtonWrapper
                            variant="contained"
                            color="success"
                            size="medium"
                            label="Save"
                            type="submit"
                            sx={{ backgroundColor: '#157CB3' }}
                        />
                    </div>
                </div>}
            </form>

        </section>
    );
};

export default SubStep4;
